import { 
        faEllipsisV, 
        faAngleDown, 
        faCheck, 
        faCommentAlt, 
        faMapMarkerAlt, 
        faStoreAlt,  
        faSearch, 
        faSlidersH, 
        faFolderOpen, 
        faRoute, 
        faPlus, 
        faArrowLeft, 
        faTimes, 
        faLocationArrow, 
        faEdit, 
        faCalendarAlt, 
        faPen, 
        faTrashAlt, 
        faArrowsAlt, 
        faCamera, 
        faCaretDown, 
        faCaretUp, 
        faBars, 
        faInfo, 
        faArrowRight, 
        faPlusCircle,
        faCog,
        faInfoCircle,
        faBook,
        faSignOutAlt,
        faClipboardList,
        faLayerGroup,
        faFileExcel,
        faEnvelope
    } from '@fortawesome/free-solid-svg-icons'

var iconList = [
    faEllipsisV, 
    faAngleDown, 
    faCheck, 
    faCommentAlt, 
    faMapMarkerAlt, 
    faStoreAlt,  
    faSearch, 
    faSlidersH, 
    faFolderOpen, 
    faRoute, 
    faPlus, 
    faArrowLeft, 
    faTimes, 
    faLocationArrow, 
    faEdit, 
    faCalendarAlt, 
    faPen, 
    faTrashAlt, 
    faArrowsAlt, 
    faCamera, 
    faCaretDown, 
    faCaretUp, 
    faBars, 
    faInfo, 
    faArrowRight, 
    faPlusCircle,
    faCog,
    faInfoCircle,
    faBook,
    faSignOutAlt,
    faClipboardList,
    faLayerGroup,
    faFileExcel,
    faEnvelope
]

export default iconList